import { ApiCaller, FullfilledApiResponse } from 'apis/ApiCaller';

export type Collection = {
    CollectionId: number;
    DateCreate: string | null;
    DateModify: string | null;
    Description: string;
    HasLogin: boolean;
    Name: string;
};

export type CollectionLoginUser = {
    FirstName: string;
    LastName: string;
    Username: string;
};

export type CollectionPartner = {
    Active: boolean;
    Country: string;
    DateCreate: string;
    Id: number;
    Name: string;
    Sector: number;
};

export type AvailablePartner = {
    Active: boolean;
    ContactEmail: string;
    Country: { Id: number; Name: string } | null;
    DateCreate: string;
    ID: number;
    Name: string;
    Sector: string;
    State: { Id: number; Name: string } | null;
    UserList: string;
};

export type CollectionDetail = {
    Collection: Collection;
    LoginUsers: CollectionLoginUser[];
    Partners: CollectionPartner[];
};

export class CollectionApi {

    private static apiCaller = new ApiCaller('Collections');

    public static GetAll(): Promise<Collection[]> {

        return this.apiCaller.GET<Collection[]>('GetAll');

    }

    public static Get(collectionId: number): Promise<CollectionDetail> {

        return this.apiCaller.GET<CollectionDetail>('Get', { collectionId });

    }

    public static GetAvailablePartners(): Promise<AvailablePartner[]> {

        return this.apiCaller.GET<AvailablePartner[]>('GetAvailablePartners');

    }

    public static GetCollectionPartners(collectionId: number): Promise<CollectionPartner[]> {

        return this.apiCaller.GET<CollectionPartner[]>('GetCollectionPartners', { collectionId });

    }

    public static Create(
        name: string,
        description: string,
        partnerIds: string,
        createLogin: boolean,
        email?: string,
        firstName?: string,
        lastName?: string
    ): Promise<FullfilledApiResponse> {

        return this.apiCaller.POST<FullfilledApiResponse>('Create', {
            name,
            createLogin,
            description,
            email: email ?? null,
            firstName: firstName ?? null,
            lastName: lastName ?? null,
            partnerIds
        });

    }

    public static Update(
        collectionId: number,
        name: string,
        description: string,
        partnerIds: string
    ): Promise<FullfilledApiResponse> {

        return this.apiCaller.PUT<FullfilledApiResponse>('Update', {
            name,
            collectionId,
            description,
            partnerIds
        });

    }

}
